<template>
    <div>
        <loading v-if="showLoading"></loading>
        <account-status :account_status="account_status"></account-status>

        <div class="widget has-shadow">

            <div class="widget-body welcome">
                <i class="fad fa-store-alt"></i>
                <h3>به مرکز فروشندگان طلا خانم خوش آمدید</h3>
                <span>همین الان گالری طلاتو بساز</span>
                <router-link :to="$base_url+'/products/add'">افزودن محصول جدید</router-link>
                <a :href="$siteUrl+'/shop/'+this.brand" target="_blank" style="color: rgb(228, 168, 44)">مشاهده گالری طلای من</a>
             </div>
            
        </div> 
    </div>
</template>

<script>
import myMinix from '../myMixin';
export default {
    components:{},
    mixins:[myMinix],
    data(){
        return {
            account_status:'active',
            showLoading:false,
            page:1,
            orderList:{data:[]},
            brand:''
        }
    },
    mounted(){
       this.account_status=localStorage.getItem('account_status');
       this.getOrders();
    },
    methods:{
        show_account_status:function()
        {
           this.account_status=localStorage.getItem('account_status');
        },
        getOrders:function(){
            this.showLoading=true;
            const url=this.$siteUrl+'/api/seller/brand';
            this.axios.get(url,this.setHeader()).then(response=>{
                this.showLoading=false;
                const result=this.setAccountStatus(response.data);

                if(result)
                {
                    this.brand=response.data;
                }
            }).catch((error)=>{
                this.showLoading=false;
                this.setCatch(error);
            });
        }
    }
}
</script>

<style>

</style>